export default "__VITE_ASSET__a451ffa5__"